import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { InvoiceDetailsComponent } from '../../../../components/admin-dashboard-component/invoices/invoice-details-component/invoice-details-component';

@Component({
  selector: 'app-invoice-details',
  imports: [InvoiceDetailsComponent],
  templateUrl: './invoice-details.html',
  styleUrl: './invoice-details.scss',
})
export class InvoiceDetails {
  private route = inject(ActivatedRoute);

  invoiceId = this.route.snapshot.paramMap.get('id') ?? '';
}